import React, { useState ,useEffect } from 'react';
import { Link } from 'react-router-dom'
import logodark from '../../assets/images/logo/logo.png'
import logofooter from '../../assets/images/logo/logo.png'
const Footer = () => {
    const accountList = [
        {
            title: "Vật phẩm",
            link: "/marketplace"
        },
        {
            title: "Bán cho chúng tôi",
            link: "/sell"
        },
        {
            title: "Đặt hàng",
            link: "/order"
        },
    ]
    const companyList = [
        {
            title: "Liên hệ",
            link: "/contact"
        },
        {
            title: "Hợp tác",
            link: "/collab"
        },
    ]
    const socialList = [
        {
            icon: "fab fa-steam",
            link: "https://steamcommunity.com/id/shu0ku0chi"
        },
        {
            icon: "fab fa-facebook-messenger",
            link: "https://www.facebook.com/shuskincs2/"
        },
        {
            icon: "fab fa-facebook",
            link: "https://www.facebook.com/groups/cs2tradingmarket"
        },
        {
            icon: "fab fa-youtube",
            link: "https://www.youtube.com/@ShuSkin"
        },
        {
            icon: "icon-fl-vt",
            link: "https://discord.gg/8zcdHrZh"
        }
    ]

    const [isVisible, setIsVisible] = useState(false);

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    };

    useEffect(() => {
      const toggleVisibility = () => {
        if (window.pageYOffset > 500) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      };

      window.addEventListener("scroll", toggleVisibility);

      return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);


    return (
        <div>
            <footer id="footer" className="footer-light-style clearfix bg-style">
                <div className="themesflat-container">
                    <div className="row">
                        <div className="col-lg-5 col-md-12 col-12">
                            <div className="widget widget-logo">
                                <div className="logo-footer" id="logo-footer">
                                    <Link to="/">
                                        <img className='logo-dark' id="logo_footer" src={logodark} alt="nft-gaming" />
                                        <img className='logo-light' id="logo_footer" src={logofooter} alt="nft-gaming" />

                                    </Link>
                                </div>
                                <p className="sub-widget-logo">
                                    <p>We have collaborated on the Steam platform for 12 years since April 14, 2012.</p>
                                    <p>This is our product, developed with all the effort and dedication of our team.</p>
                                    <p>Shuskin - The best way to trade </p>
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-5 col-5">
                            <div className="widget widget-menu style-1">
                                <h5 className="title-widget">Tính năng</h5>
                                <ul>
                                    {
                                        accountList.map((item,index) =>(
                                            <li key={index}><Link to={item.link}>{item.title}</Link></li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-7 col-7">
                            <div className="widget widget-menu style-2">
                                <h5 className="title-widget">Liên hệ & Hợp tác</h5>
                                <ul>
                                    {
                                        companyList.map((item,index) =>(
                                            <li key={index}><Link to={item.link}>{item.title}</Link></li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-7 col-12">
                            <div className="widget widget-subcribe">
                                <h5 className="title-widget">Thông tin</h5>
                                <div className="widget-social style-1 mg-t32">
                                    <ul>
                                        {
                                            socialList.map((item,index) =>(
                                                <li key={index}><Link to={item.link}><i className={item.icon}></i></Link></li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            {
                isVisible &&
                <Link onClick={scrollToTop}  to='#' id="scroll-top"></Link>
            }

            <div className="modal fade popup" id="popup_bid" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div className="modal-body space-y-20 pd-40">
                            <h3>Mua vật phẩm</h3>
                            <p className="text-center"><span className="price color-popup">★ Karambit | Doppler</span>
                            </p>
                            <div className="hr"></div>
                            <div className="d-flex justify-content-between">
                                <p className="text-left price color-popup"> Minimal Wear</p>
                                <p className="text-center price color-popup"> Ruby</p>
                                <p className="text-right price color-popup"> 0.1122412</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p> Giá:</p>
                                <p className="text-right price color-popup"> 100.000 vnđ</p>
                            </div>
                            <input type="text" className="form-control"
                                placeholder="Link offer" />
                            <Link to="/login" className="btn btn-primary" data-toggle="modal" data-target="#popup_bid_success" data-dismiss="modal" aria-label="Close"> Mua</Link>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    );
}

export default Footer;
